import React, {Component} from 'react';
import Tooltip from "react-bootstrap/Tooltip";
import {FaEdit, FaTrash, FaCog} from "react-icons/fa";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {Link} from "react-router-dom";
import { Dropdown } from 'react-bootstrap';

class ListVpsComponent extends Component {

    loadStatus = () => {
        if ( this.props.service.status_vps === 'on' ) {
            return (
                <span className="text-success">
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'off' ) {
            return (
                <span className="text-danger">
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'admin_off' ) {
            return (
                <span className="text-danger">
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'progressing' ) {
            return (
                <span className="text-info">
                    Đang tạo
                </span>
            )
        }
        else if (  this.props.service.status_vps === 'waiting' ) {
            return (
                <span className="text-info">
                    Đang chờ tạo
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'rebuild' ) {
            return (
                <span className="text-info">
                    Đang tạo lại
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'reset_password' ) {
            return (
                <span className="text-info">
                    Đang đặt lại mật khẩu
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'change_ip' ) {
            return (
                <span className="text-info">
                    Đang đổi IP
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'expire' ) {
            return (
                <span className="text-danger">
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'cancel' ) {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'delete' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'delete_vps' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'change_user' ) {
            return (
                <span className="text-danger">
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className="text-danger">
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = (event) => {
        if ( event.nativeEvent.shiftKey ) {
            let value = event.target.checked;
            this.props.checkedServiceShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedService( this.props.actionKey );
        }
    }

    render() {
        return (
            <tr>
                <td>
                    <input type="checkbox" value="1" checked={this.props.service.checked}  onChange={ this.checkedService } />
                </td>
                <td>
                    <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.service.user_id}>{this.props.service.text_user_name}</Link>
                </td>
                <td>
                    <Link to={'/admin/vps/' + this.props.service.id + '/chinh-sua.html'}>{this.props.service.ip}</Link>
                </td>
                <td>
                    { this.props.service.text_config }
                </td>
                <td>
                    { this.props.service.text_create_date }
                </td>
                <td>
                    { this.props.service.text_next_due_date }
                </td>
                <td>
                    { this.props.service.text_total_time }
                </td>
                <td>
                    { this.props.service.text_billing_cycle }
                </td>
                <td>
                    { this.props.service.text_amount }
                </td>
                <td>
                    { this.loadStatus() }
                </td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chỉnh sửa VPS
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link to={'/admin/vps/' + this.props.service.id + '/chinh-sua.html'} className="btn btn-warning btn-sm mr-1 text-light">
                            <FaEdit />
                        </Link>
                    </OverlayTrigger>
                    {
                        this.props.service.status_vps === 'off' || this.props.service.status_vps === 'on' ? (
                            <>
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Hành động
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <Dropdown className="btn mr-1 p-0">
                                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-sm">
                                            <FaCog />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {
                                                this.props.service.status_vps === 'off' ? (
                                                    <>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'on' ) }>Bật</Dropdown.Item>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'restart' ) }>Khởi động lại</Dropdown.Item>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'rebuild' ) }>Cài đặt lại</Dropdown.Item>
                                                        <Dropdown.Item>
                                                            <Link class="text-dark" to={"/admin/vps/chuyen-khach-hang.html?listVpsId=" + this.props.service.id}>Chuyển khách hàng</Link>
                                                        </Dropdown.Item>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            {
                                                this.props.service.status_vps === 'on' ? (
                                                    <>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'off' ) }>Tắt</Dropdown.Item>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'restart' ) }>Khởi động lại</Dropdown.Item>
                                                        <Dropdown.Item>
                                                            <Link class="text-dark" to={"/admin/vps/" + this.props.service.id + "/console-vps.html"}>Truy cập Console</Link>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'rebuild' ) }>Cài đặt lại</Dropdown.Item>
                                                        <Dropdown.Item>
                                                            <Link class="text-dark" to={"/admin/vps/chuyen-khach-hang.html?listVpsId=" + this.props.service.id}>Chuyển khách hàng</Link>
                                                        </Dropdown.Item>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            {/*{*/}
                                            {/*    this.props.service.status === 'Active' ? (*/}
                                            {/*        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'logActivity' ) }>Nhật ký hoạt động</Dropdown.Item>*/}
                                            {/*    ) : (*/}
                                            {/*        <></>*/}
                                            {/*    )*/}
                                            {/*}*/}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </OverlayTrigger>
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.service.vm_id !== -1 ? (
                            <OverlayTrigger
                                delay={{ hide: 450, show: 300 }}
                                overlay={(props) => (
                                    <Tooltip {...props}>
                                        Xóa VPS
                                    </Tooltip>
                                )}
                                placement="top"
                            >
                                <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.actionKey, 'delete' ) }>
                                    <FaTrash />
                                </button>
                            </OverlayTrigger>
                        ) : (
                            <></>
                        )
                    }
                </td>
            </tr>
        );
    }
}

export default ListVpsComponent;